<template>
  <div class="app-sidebar" :class="{ collapsed: isSideNavCollapsed }">
    <div class="sidebar-items-container">
      <sidebar-items />
    </div>
  </div>
</template>

<script>
import SidebarItems from "./SidebarItems";
export default {
  components: {
    SidebarItems,
  },
  computed: {
    isSideNavCollapsed() {
      return this.$store.getters.isSideNavCollapsed;
    },
  },
};
</script>

<style scoped>
.app-sidebar {
  display: flex;
  flex-direction: column;
  position: fixed !important;
  top: 4rem;
  height: calc(100vh - 4rem);
  width: 20vw;
  max-width: 100% !important;
  background: #0253b3 !important;
  color: #ffffff !important;
  margin: 0 !important;
  outline: 0;
  transform: translateX(0);
  overflow-y: auto;
  z-index: 900;
  transition: all ease 0.3s;
}
.app-sidebar.collapsed {
  width: 3vw;
  overflow-x: hidden;
  overflow-y: auto;
}
.sidebar-items-container {
  margin-top: 2rem;
}
::-webkit-scrollbar {
  width: 0.05rem;
  display: none;
}

/* Track */
::-webkit-scrollbar-track {
  display: none;
  box-shadow: inset 0 0 5px grey;
  border-radius: 10px;
  background: none;
}

/* Handle */
::-webkit-scrollbar-thumb {
  background: #ffffff;
  opacity: 0.6;
  border-radius: 10px;
}
@media screen and (max-width: 1024px) {
  .app-sidebar {
    position: absolute;
    right: 0;
    width: 100%;
    display: none;
  }
}
</style>
